
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // Libs
import { CommunityConfig } from '@/lib/analytics/pages/community';
// Components
import { LayoutAnalyticsSwitch } from '@/components/layouts/wrappers/LayoutAnalytics/LayoutAnalyticsSwitch';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
const Community = () => (<WrapperSwitchLayout>
        <LayoutAnalyticsSwitch profileConfig={CommunityConfig} title="commons:menu.community" withCoreEventPendo/>
    </WrapperSwitchLayout>);
export default Community;

    async function __Next_Translate__getStaticProps__19344c34a46__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/analytics/community',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19344c34a46__ as getStaticProps }
  